import { Component, OnInit } from '@angular/core';
import { LicenceService } from '../licence.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrencyService } from '../../../shared/currency.service';
import { AnalyticsService } from 'src/app/shared/analytics/analytics.service';
import {Location} from '@angular/common';

@Component({
  selector: 'app-licence-country-band',
  templateUrl: './licence-country-band.component.html',
  styleUrls: ['./licence-country-band.component.scss']
})

export class LicenceCountryBandComponent implements OnInit {

  licenceCountryBandData : any;
  graphicMode : boolean = false;

  constructor(
    private licenceService: LicenceService,
    private route: ActivatedRoute,
    private router: Router,
    public currencyService : CurrencyService,
    public analyticsService: AnalyticsService,
    private location: Location
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };
  }

  ngOnInit() {
    this.route.params.subscribe(p => {
      this.licenceService.getLicencesByCountryBand(p.countryCode, p.bandCode)
      .subscribe(data => {
        this.licenceCountryBandData=data;
      });
    });

    this.route.fragment.subscribe((fragment: string) => {
        if(fragment && fragment=='graphic'){
          this.graphicMode=true;

        }
    });
  }

  toggleActiveMode() {
    this.analyticsService.pushEvent('toggleGraphicView');
    this.graphicMode=!this.graphicMode;
    if(this.graphicMode){
      this.location.go(this.router.url.split('#')[0]+"#graphic");
    }else{
      this.location.go(this.router.url.split('#')[0]+"#table");
    }
  }

  isGraphicDataAvailable(){
    let fd= this.licenceCountryBandData.frequencyDistribution;
    return fd
  }

  isGraphicMode() {
    return this.graphicMode;
  }

  isTableMode() {
    return !this.isGraphicMode();
  }

  hideLicensee(row : any): boolean {
    return !row.licensee && !row.licenseeComment;
  }

  hideScope(row : any): boolean {
    return !row.geoScope && !row.geoScopeComment;
  }

  hideMHz(row : any): boolean {
    return !row.bandwidth && !row.mhzFromTo;
  }

  hideAward(row : any): boolean {
    return !row.award || !row.award.type && !row.award.awardKey;
  }

  hideDuration(row : any): boolean {
    return !row.duration && !row.beginDate && !row.beginDateComment && !row.endDate && !row.endDateComment;
  }

  hideLicenceFee(row : any): boolean {
    return !row.fee || (!row.fee.priceEUR && !row.feeComment);
  }

  hideLegalName(row : any): boolean {
    return row.licensee == row.licenseeLegalName;
  }

  showAsterisk(operator : any, groupedNames : any): boolean {
    return operator.value == 'Regional licences' && groupedNames;
  }

  isSpectrumLightContent(value: string) {
    if (value === 'BLUR_CONTENT') {
      return '<p class="SpectrumLight">Upgrade...</p>';
    } else {
      return value;
    }
  }

  isSpectrumLightComment(value: string) {
    if (value === 'BLUR_COMMENT') {
      return '';
    } else {
      return value;
    }
  }
}
